import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { Onboarding } from '@bciti/types';
import { Subject } from 'rxjs';
import { map, takeUntil, tap } from 'rxjs/operators';
import { OnboardingService } from 'src/app/services/onboarding/onboarding.service';
import { transform } from 'typescript';
import { OnboardingCreateDialogComponent } from './onboarding-create-dialog/onboarding-create-dialog.component';

@Component({
    selector: 'app-onboardings',
    templateUrl: './onboardings.component.html',
    styleUrls: ['./onboardings.component.scss'],
})
export class OnboardingsComponent implements OnDestroy {
    destroy$ = new Subject();
    dataSource: MatTableDataSource<Partial<Onboarding>> = new MatTableDataSource<Partial<Onboarding>>();
    displayedColumns: string[] = ['organisation.name', 'organisation.tag', 'status'];

    loading = true;

    dataSource$ = this.service.getOnboardings().pipe(
        takeUntil(this.destroy$),
        map((onboardings) => {
            const dataSource = this.dataSource;
            dataSource.data = onboardings;
            dataSource.filterPredicate = (data, filter) => {
                const filterKeys: string[] = ['name', 'tag'];

                // Search through data.organisation object for filterKeys
                const dataStr = Object.keys(data?.organisation)
                    .reduce((currentTerm: string, key: string) => {
                        if (filterKeys.includes(key)) {
                            return currentTerm + (data?.organisation as { [key: string]: any })[key] + '◬';
                        } else {
                            return currentTerm;
                        }
                    }, '')
                    .toLowerCase();

                const transformedFilter = filter.trim().toLowerCase();
                return dataStr.indexOf(transformedFilter) !== -1;
            };

            this.loading = false;
            return dataSource;
        }),
    );

    constructor(private dialog: MatDialog, private service: OnboardingService, private router: Router) {}

    openCreateOnboardingDialog() {
        this.dialog
            .open(OnboardingCreateDialogComponent, {
                panelClass: 'onboarding-create-dialog',
                disableClose: true,
            })
            .afterClosed()
            .subscribe((result) => {
                console.log('afterClosed', result);
                if (result) {
                    this.router.navigate([`/onboarding/${result._id}`]);
                }
            });
    }

    applyFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.dataSource.filter = filterValue.trim().toLowerCase();
    }

    handleClick($event) {
        console.log($event);
        this.router.navigate([`/onboarding/${$event._id}`]);
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
